import React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '@/components/common/base-button/BaseButton';
import FindLocationIcon from '@/components/icons/parking/FindLocation';
import BackArrowIcon from '@/components/icons/parking/BackArrow';
import styles from './ParkingActionButtons.module.scss';
import clsx from 'clsx';

interface ParkingActionButtonsProps {
    isUseLocation: boolean;
    onSearchAgain: () => void;
    translationPrefix: 'parking.header' | 'parking.detail';
    className?: string;
    handleDirectionGuide: () => void;
}

const ParkingActionButtons: React.FC<ParkingActionButtonsProps> = ({
    isUseLocation,
    onSearchAgain,
    translationPrefix,
    className = '',
    handleDirectionGuide,
}) => {
    const { t } = useTranslation();

    return (
        <div className={`flex justify-center gap-[calc(24*var(--vw-unit))] ${className}`}>
            {isUseLocation && (
                <BaseButton
                    data-region-nav
                    data-region-order={5}
                    data-interactive
                    tabIndex={5}
                    aria-label={t(`${translationPrefix}.text.directionGuide`)}
                    className={clsx(
                        styles['parking-action-buttons'],
                        'flex h-[calc(174*var(--vh-unit))] w-[calc(174*var(--vw-unit))] flex-col items-center justify-center gap-[calc(4*var(--vh-unit))] rounded-[calc(24*var(--vh-unit))] border-[calc(2*var(--vh-unit))] border-transparent bg-[var(--color-black)] p-[calc(24*var(--vh-unit))]'
                    )}
                    onClick={handleDirectionGuide}
                    role="button"
                >
                    <div>
                        <FindLocationIcon style={{ width: 'calc(81*var(--vw-unit))', height: 'calc(80*var(--vh-unit))' }} color="var(--color-text-white)" />
                        <span className="text-[calc(20*var(--vh-unit))] leading-normal font-medium text-[var(--color-text-white)]">
                            {t(`${translationPrefix}.text.directionGuide`)}
                        </span>
                    </div>
                </BaseButton>
            )}
            <BaseButton
                data-region-nav
                data-region-order={6}
                data-interactive
                aria-label={t(`${translationPrefix}.text.searchAgain`)}
                tabIndex={6}
                className={clsx(
                    styles['parking-action-buttons'],
                    'flex h-[calc(174*var(--vh-unit))] w-[calc(174*var(--vw-unit))] flex-col items-center justify-center gap-[calc(4*var(--vh-unit))] rounded-[calc(24*var(--vh-unit))] border-[calc(2*var(--vh-unit))] border-[var(--color-border-transparent-to-sub01)] bg-[var(--color-text-sub01-to-black)] p-[calc(24*var(--vh-unit))]'
                )}
                onClick={onSearchAgain}
                role="button"
            >
                <div>
                    <BackArrowIcon style={{ width: 'calc(81*var(--vw-unit))', height: 'calc(80*var(--vh-unit))' }} color="var(--color-text-white-to-yellow)" />
                    <span className="text-[calc(20*var(--vh-unit))] leading-normal font-medium text-[var(--color-text-white-to-yellow)]">
                        {t(`${translationPrefix}.text.searchAgain`)}
                    </span>
                </div>
            </BaseButton>
        </div>
    );
};

export default ParkingActionButtons;
